"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Typography_1 = require("../../../../UI/Typography");
const MenuItemSecond_1 = __importDefault(require("./MenuItemSecond"));
const style = __importStar(require("./styled"));
const react_redux_1 = require("react-redux");
const megamenu_1 = require("@/Redux/Actions/megamenu");
const spa_core_1 = require("@episerver/spa-core");
const MenuItemFirst = ({ title, uri, secondLevelItems }) => {
    const isMegaMenuOpen = (0, react_redux_1.useSelector)((state) => state.menuToggle.isOpen);
    const dispatch = (0, react_redux_1.useDispatch)();
    const cmsState = (0, spa_core_1.useCmsState)();
    const isForceReloadLink = `${!(cmsState === null || cmsState === void 0 ? void 0 : cmsState.iContent)}`;
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!isMegaMenuOpen) {
            setIsOpen(false);
        }
    }, [isMegaMenuOpen, setIsOpen]);
    return (react_1.default.createElement(style.Container, null,
        react_1.default.createElement(style.MenuItemContainer, { isOpen: isOpen, type: style.ItemLevel.FIRST },
            react_1.default.createElement(style.MenuItemFirst, { type: Typography_1.Types.MOBILE_MENU_ITEM, isOpen: isOpen },
                react_1.default.createElement(style.Link, { href: uri, onClick: () => dispatch((0, megamenu_1.setIsMegaMenuOpen)(false)), "data-force-reload": isForceReloadLink }, title)),
            secondLevelItems.length > 0 && (react_1.default.createElement(style.TouchArea, null,
                react_1.default.createElement(style.IconWrapper, { onClick: () => setIsOpen(!isOpen) }, isOpen ? react_1.default.createElement(style.MinusIcon, null) : react_1.default.createElement(style.PlusIcon, null))))),
        isOpen && secondLevelItems.length > 0 && secondLevelItems.map((item, i) => react_1.default.createElement(MenuItemSecond_1.default, Object.assign({ key: i }, item)))));
};
exports.default = MenuItemFirst;
